import { render } from "./Past.vue?vue&type=template&id=47972e79"
import script from "./Past.vue?vue&type=script&lang=js"
export * from "./Past.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Kuppen_front/Kuppen_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__